!function(root, factory) {
    "object" == typeof exports && "object" == typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define([], factory) : "object" == typeof exports ? exports.ReactImageLightbox = factory() : root.ReactImageLightbox = factory();
}("undefined" != typeof self ? self : this, function() {
    /******/
    return function(modules) {
        /******/
        /******/
        // The require function
        /******/
        function __webpack_require__(moduleId) {
            /******/
            /******/
            // Check if module is in cache
            /******/
            if (installedModules[moduleId]) /******/
            return installedModules[moduleId].exports;
            /******/
            // Create a new module (and put it into the cache)
            /******/
            var module = installedModules[moduleId] = {
                /******/
                i: moduleId,
                /******/
                l: !1,
                /******/
                exports: {}
            };
            /******/
            /******/
            // Return the exports of the module
            /******/
            /******/
            /******/
            // Execute the module function
            /******/
            /******/
            /******/
            // Flag the module as loaded
            /******/
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        // webpackBootstrap
        /******/
        // The module cache
        /******/
        var installedModules = {};
        /******/
        /******/
        // Load entry module and return exports
        /******/
        /******/
        /******/
        /******/
        // expose the modules object (__webpack_modules__)
        /******/
        /******/
        /******/
        // expose the module cache
        /******/
        /******/
        /******/
        // define getter function for harmony exports
        /******/
        /******/
        /******/
        // getDefaultExport function for compatibility with non-harmony modules
        /******/
        /******/
        /******/
        // Object.prototype.hasOwnProperty.call
        /******/
        /******/
        /******/
        // __webpack_public_path__
        /******/
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            /******/
            __webpack_require__.o(exports, name) || /******/
            Object.defineProperty(exports, name, {
                /******/
                configurable: !1,
                /******/
                enumerable: !0,
                /******/
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            /******/
            var getter = module && module.__esModule ? /******/
            function() {
                return module.default;
            } : /******/
            function() {
                return module;
            };
            /******/
            /******/
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 1);
    }([ /* 0 */
    /***/
    function(module, exports) {
        var g;
        // This works in non-strict mode
        g = function() {
            return this;
        }();
        try {
            // This works if eval is allowed (see CSP)
            g = g || Function("return this")() || (0, eval)("this");
        } catch (e) {
            // This works if the window reference is available
            "object" == typeof window && (g = window);
        }
        // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}
        module.exports = g;
    }, /* 1 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = __webpack_require__(2).default;
    }, /* 2 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */
        (function(global) {
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
                    return arr2;
                }
                return Array.from(arr);
            }
            function _defineProperty(obj, key, value) {
                return key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value, obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [], _n = !0, _d = !1, _e = void 0;
                    try {
                        for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                        !i || _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            !_n && _i.return && _i.return();
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }(), _createClass = function() {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                        "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                    Constructor;
                };
            }(), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(4), _propTypes2 = _interopRequireDefault(_propTypes), _reactModal = __webpack_require__(5), _reactModal2 = _interopRequireDefault(_reactModal), _util = __webpack_require__(6), _constant = __webpack_require__(7), _style = __webpack_require__(8), _style2 = _interopRequireDefault(_style), styles = _style2.default, ieVersion = (0, 
            _util.getIEVersion)();
            ieVersion < 10 && (styles = _extends({}, styles, {
                toolbarSide: styles.toolbarSide + " " + styles.toolbarSideNoFlex,
                toolbarLeftSide: styles.toolbarLeftSide + " " + styles.toolbarLeftSideNoFlex,
                toolbarRightSide: styles.toolbarRightSide + " " + styles.toolbarRightSideNoFlex
            }));
            var ReactImageLightbox = function(_Component) {
                function ReactImageLightbox(props) {
                    _classCallCheck(this, ReactImageLightbox);
                    var _this = _possibleConstructorReturn(this, (ReactImageLightbox.__proto__ || Object.getPrototypeOf(ReactImageLightbox)).call(this, props));
                    return _this.state = {
                        //-----------------------------
                        // Animation
                        //-----------------------------
                        // Lightbox is closing
                        // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
                        isClosing: !props.animationDisabled,
                        // Component parts should animate (e.g., when images are moving, or image is being zoomed)
                        shouldAnimate: !1,
                        //-----------------------------
                        // Zoom settings
                        //-----------------------------
                        // Zoom level of image
                        zoomLevel: _constant.MIN_ZOOM_LEVEL,
                        //-----------------------------
                        // Image position settings
                        //-----------------------------
                        // Horizontal offset from center
                        offsetX: 0,
                        // Vertical offset from center
                        offsetY: 0,
                        // image load error for srcType
                        loadErrorStatus: {}
                    }, _this.closeIfClickInner = _this.closeIfClickInner.bind(_this), _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_this), 
                    _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_this), _this.handleKeyInput = _this.handleKeyInput.bind(_this), 
                    _this.handleMouseUp = _this.handleMouseUp.bind(_this), _this.handleMouseDown = _this.handleMouseDown.bind(_this), 
                    _this.handleMouseMove = _this.handleMouseMove.bind(_this), _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_this), 
                    _this.handleTouchStart = _this.handleTouchStart.bind(_this), _this.handleTouchMove = _this.handleTouchMove.bind(_this), 
                    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this), _this.handlePointerEvent = _this.handlePointerEvent.bind(_this), 
                    _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_this), _this.handleWindowResize = _this.handleWindowResize.bind(_this), 
                    _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_this), _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_this), 
                    _this.requestClose = _this.requestClose.bind(_this), _this.requestMoveNext = _this.requestMoveNext.bind(_this), 
                    _this.requestMovePrev = _this.requestMovePrev.bind(_this), _this;
                }
                return _inherits(ReactImageLightbox, _Component), _createClass(ReactImageLightbox, null, [ {
                    key: "isTargetMatchImage",
                    value: function(target) {
                        return target && /ril-image-current/.test(target.className);
                    }
                }, {
                    key: "parseMouseEvent",
                    value: function(mouseEvent) {
                        return {
                            id: "mouse",
                            source: _constant.SOURCE_MOUSE,
                            x: parseInt(mouseEvent.clientX, 10),
                            y: parseInt(mouseEvent.clientY, 10)
                        };
                    }
                }, {
                    key: "parseTouchPointer",
                    value: function(touchPointer) {
                        return {
                            id: touchPointer.identifier,
                            source: _constant.SOURCE_TOUCH,
                            x: parseInt(touchPointer.clientX, 10),
                            y: parseInt(touchPointer.clientY, 10)
                        };
                    }
                }, {
                    key: "parsePointerEvent",
                    value: function(pointerEvent) {
                        return {
                            id: pointerEvent.pointerId,
                            source: _constant.SOURCE_POINTER,
                            x: parseInt(pointerEvent.clientX, 10),
                            y: parseInt(pointerEvent.clientY, 10)
                        };
                    }
                }, {
                    key: "getTransform",
                    value: function(_ref) {
                        var _ref$x = _ref.x, x = void 0 === _ref$x ? 0 : _ref$x, _ref$y = _ref.y, y = void 0 === _ref$y ? 0 : _ref$y, _ref$zoom = _ref.zoom, zoom = void 0 === _ref$zoom ? 1 : _ref$zoom, width = _ref.width, targetWidth = _ref.targetWidth, nextX = x, isOldIE = ieVersion < 10, windowWidth = (0, 
                        _util.getWindowWidth)();
                        width > windowWidth && (nextX += (windowWidth - width) / 2);
                        var scaleFactor = zoom * (targetWidth / width);
                        return isOldIE ? {
                            msTransform: "translate(" + nextX + "px," + y + "px) scale(" + scaleFactor + ")"
                        } : {
                            transform: "translate3d(" + nextX + "px," + y + "px,0) scale3d(" + scaleFactor + "," + scaleFactor + ",1)"
                        };
                    }
                }, {
                    key: "loadStyles",
                    value: function() {
                        // Insert component styles
                        void 0 !== global.window && // eslint-disable-next-line no-underscore-dangle
                        styles._insertCss();
                    }
                } ]), _createClass(ReactImageLightbox, [ {
                    key: "componentWillMount",
                    value: function() {
                        // Timeouts - always clear it before umount
                        this.timeouts = [], // Current action
                        this.currentAction = _constant.ACTION_NONE, // Events source
                        this.eventsSource = _constant.SOURCE_ANY, // Empty pointers list
                        this.pointerList = [], // Prevent inner close
                        this.preventInnerClose = !1, this.preventInnerCloseTimeout = null, // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
                        this.keyPressed = !1, // Used to store load state / dimensions of images
                        this.imageCache = {}, // Time the last keydown event was called (used in keyboard action rate limiting)
                        this.lastKeyDownTime = 0, // Used for debouncing window resize event
                        this.resizeTimeout = null, // Used to determine when actions are triggered by the scroll wheel
                        this.wheelActionTimeout = null, this.resetScrollTimeout = null, this.scrollX = 0, 
                        this.scrollY = 0, // Used in panning zoomed images
                        this.moveStartX = 0, this.moveStartY = 0, this.moveStartOffsetX = 0, this.moveStartOffsetY = 0, 
                        // Used to swipe
                        this.swipeStartX = 0, this.swipeStartY = 0, this.swipeEndX = 0, this.swipeEndY = 0, 
                        // Used to pinch
                        this.pinchTouchList = null, this.pinchDistance = 0, // Used to differentiate between images with identical src
                        this.keyCounter = 0, // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
                        this.moveRequested = !1, this.props.animationDisabled || // Make opening animation play
                        this.setState({
                            isClosing: !1
                        });
                    }
                }, {
                    key: "componentDidMount",
                    value: function() {
                        var _this2 = this;
                        ReactImageLightbox.loadStyles(), this.listeners = {
                            resize: this.handleWindowResize,
                            mouseup: this.handleMouseUp,
                            touchend: this.handleTouchEnd,
                            touchcancel: this.handleTouchEnd,
                            pointerdown: this.handlePointerEvent,
                            pointermove: this.handlePointerEvent,
                            pointerup: this.handlePointerEvent,
                            pointercancel: this.handlePointerEvent
                        }, Object.keys(this.listeners).forEach(function(type) {
                            global.window.top.addEventListener(type, _this2.listeners[type]);
                        }), this.loadAllImages();
                    }
                }, {
                    key: "componentWillReceiveProps",
                    value: function(nextProps) {
                        var _this3 = this, sourcesChanged = !1, prevSrcDict = {}, nextSrcDict = {};
                        this.getSrcTypes().forEach(function(srcType) {
                            _this3.props[srcType.name] !== nextProps[srcType.name] && (sourcesChanged = !0, 
                            prevSrcDict[_this3.props[srcType.name]] = !0, nextSrcDict[nextProps[srcType.name]] = !0);
                        }), (sourcesChanged || this.moveRequested) && (// Reset the loaded state for images not rendered next
                        Object.keys(prevSrcDict).forEach(function(prevSrc) {
                            !(prevSrc in nextSrcDict) && prevSrc in _this3.imageCache && (_this3.imageCache[prevSrc].loaded = !1);
                        }), this.moveRequested = !1, // Load any new images
                        this.loadAllImages(nextProps));
                    }
                }, {
                    key: "shouldComponentUpdate",
                    value: function() {
                        // Wait for move...
                        return !this.moveRequested;
                    }
                }, {
                    key: "componentWillUnmount",
                    value: function() {
                        var _this4 = this;
                        this.didUnmount = !0, Object.keys(this.listeners).forEach(function(type) {
                            global.window.top.removeEventListener(type, _this4.listeners[type]);
                        }), this.timeouts.forEach(function(tid) {
                            return clearTimeout(tid);
                        });
                    }
                }, {
                    key: "setTimeout",
                    value: function(_setTimeout) {
                        function setTimeout(_x, _x2) {
                            return _setTimeout.apply(this, arguments);
                        }
                        return setTimeout.toString = function() {
                            return _setTimeout.toString();
                        }, setTimeout;
                    }(function(func, time) {
                        var _this5 = this, id = setTimeout(function() {
                            _this5.timeouts = _this5.timeouts.filter(function(tid) {
                                return tid !== id;
                            }), func();
                        }, time);
                        return this.timeouts.push(id), id;
                    })
                }, {
                    key: "setPreventInnerClose",
                    value: function() {
                        var _this6 = this;
                        this.preventInnerCloseTimeout && this.clearTimeout(this.preventInnerCloseTimeout), 
                        this.preventInnerClose = !0, this.preventInnerCloseTimeout = this.setTimeout(function() {
                            _this6.preventInnerClose = !1, _this6.preventInnerCloseTimeout = null;
                        }, 100);
                    }
                }, {
                    key: "getBestImageForType",
                    value: function(srcType) {
                        var imageSrc = this.props[srcType], fitSizes = {};
                        if (this.isImageLoaded(imageSrc)) // Use full-size image if available
                        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height); else {
                            if (!this.isImageLoaded(this.props[srcType + "Thumbnail"])) return null;
                            // Fall back to using thumbnail if the image has not been loaded
                            imageSrc = this.props[srcType + "Thumbnail"], fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, !0);
                        }
                        return {
                            src: imageSrc,
                            height: this.imageCache[imageSrc].height,
                            width: this.imageCache[imageSrc].width,
                            targetHeight: fitSizes.height,
                            targetWidth: fitSizes.width
                        };
                    }
                }, {
                    key: "getFitSizes",
                    value: function(width, height, stretch) {
                        var boxSize = this.getLightboxRect(), maxHeight = boxSize.height - 2 * this.props.imagePadding, maxWidth = boxSize.width - 2 * this.props.imagePadding;
                        return stretch || (maxHeight = Math.min(maxHeight, height), maxWidth = Math.min(maxWidth, width)), 
                        maxWidth / maxHeight > width / height ? {
                            width: width * maxHeight / height,
                            height: maxHeight
                        } : {
                            width: maxWidth,
                            height: height * maxWidth / width
                        };
                    }
                }, {
                    key: "getMaxOffsets",
                    value: function() {
                        var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel, currentImageInfo = this.getBestImageForType("mainSrc");
                        if (null === currentImageInfo) return {
                            maxX: 0,
                            minX: 0,
                            maxY: 0,
                            minY: 0
                        };
                        var boxSize = this.getLightboxRect(), zoomMultiplier = this.getZoomMultiplier(zoomLevel), maxX = 0;
                        // if there is still blank space in the X dimension, don't limit except to the opposite edge
                        maxX = zoomMultiplier * currentImageInfo.width - boxSize.width < 0 ? (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2 : (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
                        var maxY = 0;
                        // if there is still blank space in the Y dimension, don't limit except to the opposite edge
                        return maxY = zoomMultiplier * currentImageInfo.height - boxSize.height < 0 ? (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2 : (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2, 
                        {
                            maxX: maxX,
                            maxY: maxY,
                            minX: -1 * maxX,
                            minY: -1 * maxY
                        };
                    }
                }, {
                    key: "getSrcTypes",
                    value: function() {
                        return [ {
                            name: "mainSrc",
                            keyEnding: "i" + this.keyCounter
                        }, {
                            name: "mainSrcThumbnail",
                            keyEnding: "t" + this.keyCounter
                        }, {
                            name: "nextSrc",
                            keyEnding: "i" + (this.keyCounter + 1)
                        }, {
                            name: "nextSrcThumbnail",
                            keyEnding: "t" + (this.keyCounter + 1)
                        }, {
                            name: "prevSrc",
                            keyEnding: "i" + (this.keyCounter - 1)
                        }, {
                            name: "prevSrcThumbnail",
                            keyEnding: "t" + (this.keyCounter - 1)
                        } ];
                    }
                }, {
                    key: "getZoomMultiplier",
                    value: function() {
                        var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel;
                        return Math.pow(_constant.ZOOM_RATIO, zoomLevel);
                    }
                }, {
                    key: "getLightboxRect",
                    value: function() {
                        return this.outerEl ? this.outerEl.getBoundingClientRect() : {
                            width: (0, _util.getWindowWidth)(),
                            height: (0, _util.getWindowHeight)(),
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        };
                    }
                }, {
                    key: "clearTimeout",
                    value: function(_clearTimeout) {
                        function clearTimeout(_x3) {
                            return _clearTimeout.apply(this, arguments);
                        }
                        return clearTimeout.toString = function() {
                            return _clearTimeout.toString();
                        }, clearTimeout;
                    }(function(id) {
                        this.timeouts = this.timeouts.filter(function(tid) {
                            return tid !== id;
                        }), clearTimeout(id);
                    })
                }, {
                    key: "changeZoom",
                    value: function(zoomLevel, clientX, clientY) {
                        // Ignore if zoom disabled
                        if (this.props.enableZoom) {
                            // Constrain zoom level to the set bounds
                            var nextZoomLevel = Math.max(_constant.MIN_ZOOM_LEVEL, Math.min(_constant.MAX_ZOOM_LEVEL, zoomLevel));
                            // Ignore requests that don't change the zoom level
                            if (nextZoomLevel !== this.state.zoomLevel) {
                                if (nextZoomLevel === _constant.MIN_ZOOM_LEVEL) // Snap back to center if zoomed all the way out
                                return void this.setState({
                                    zoomLevel: nextZoomLevel,
                                    offsetX: 0,
                                    offsetY: 0
                                });
                                var imageBaseSize = this.getBestImageForType("mainSrc");
                                if (null !== imageBaseSize) {
                                    var currentZoomMultiplier = this.getZoomMultiplier(), nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel), boxRect = this.getLightboxRect(), pointerX = void 0 !== clientX ? clientX - boxRect.left : boxRect.width / 2, pointerY = void 0 !== clientY ? clientY - boxRect.top : boxRect.height / 2, currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2, currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2, currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX, currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY, currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier, currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier, nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier, nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier, nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2, nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2, nextOffsetX = nextImageOffsetX - nextImageRealOffsetX, nextOffsetY = nextImageOffsetY - nextImageRealOffsetY;
                                    // When zooming out, limit the offset so things don't get left askew
                                    if (this.currentAction !== _constant.ACTION_PINCH) {
                                        var maxOffsets = this.getMaxOffsets();
                                        this.state.zoomLevel > nextZoomLevel && (nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX)), 
                                        nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY)));
                                    }
                                    this.setState({
                                        zoomLevel: nextZoomLevel,
                                        offsetX: nextOffsetX,
                                        offsetY: nextOffsetY
                                    });
                                }
                            }
                        }
                    }
                }, {
                    key: "closeIfClickInner",
                    value: function(event) {
                        !this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1 && this.requestClose(event);
                    }
                }, {
                    key: "handleKeyInput",
                    value: function(event) {
                        // Ignore key input during animations
                        if (event.stopPropagation(), !this.isAnimating()) {
                            // Allow slightly faster navigation through the images when user presses keys repeatedly
                            if ("keyup" === event.type) return void (this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus);
                            var keyCode = event.which || event.keyCode, currentTime = new Date();
                            if (!(currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== _constant.KEYS.ESC)) switch (this.lastKeyDownTime = currentTime.getTime(), 
                            keyCode) {
                              // ESC key closes the lightbox
                                case _constant.KEYS.ESC:
                                event.preventDefault(), this.requestClose(event);
                                break;

                              // Left arrow key moves to previous image
                                case _constant.KEYS.LEFT_ARROW:
                                if (!this.props.prevSrc) return;
                                event.preventDefault(), this.keyPressed = !0, this.requestMovePrev(event);
                                break;

                              // Right arrow key moves to next image
                                case _constant.KEYS.RIGHT_ARROW:
                                if (!this.props.nextSrc) return;
                                event.preventDefault(), this.keyPressed = !0, this.requestMoveNext(event);
                            }
                        }
                    }
                }, {
                    key: "handleOuterMousewheel",
                    value: function(event) {
                        var _this7 = this;
                        // Prevent scrolling of the background
                        event.preventDefault(), event.stopPropagation();
                        var xThreshold = _constant.WHEEL_MOVE_X_THRESHOLD, actionDelay = 0;
                        // Prevent rapid-fire zoom behavior
                        if (this.clearTimeout(this.resetScrollTimeout), this.resetScrollTimeout = this.setTimeout(function() {
                            _this7.scrollX = 0, _this7.scrollY = 0;
                        }, 300), null === this.wheelActionTimeout && !this.isAnimating()) {
                            if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
                                // handle horizontal scrolls with image moves
                                this.scrollY = 0, this.scrollX += event.deltaX;
                                var bigLeapX = xThreshold / 2;
                                // If the scroll amount has accumulated sufficiently, or a large leap was taken
                                this.scrollX >= xThreshold || event.deltaX >= bigLeapX ? (// Scroll right moves to next
                                this.requestMoveNext(event), actionDelay = 500, this.scrollX = 0) : (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) && (// Scroll left moves to previous
                                this.requestMovePrev(event), actionDelay = 500, this.scrollX = 0);
                            }
                            // Allow successive actions after the set delay
                            0 !== actionDelay && (this.wheelActionTimeout = this.setTimeout(function() {
                                _this7.wheelActionTimeout = null;
                            }, actionDelay));
                        }
                    }
                }, {
                    key: "handleImageMouseWheel",
                    value: function(event) {
                        event.preventDefault();
                        var yThreshold = _constant.WHEEL_MOVE_Y_THRESHOLD;
                        if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
                            // If the vertical scroll amount was large enough, perform a zoom
                            if (event.stopPropagation(), Math.abs(event.deltaY) < yThreshold) return;
                            this.scrollX = 0, this.scrollY += event.deltaY, this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
                        }
                    }
                }, {
                    key: "handleImageDoubleClick",
                    value: function(event) {
                        this.state.zoomLevel > _constant.MIN_ZOOM_LEVEL ? // A double click when zoomed in zooms all the way out
                        this.changeZoom(_constant.MIN_ZOOM_LEVEL, event.clientX, event.clientY) : // A double click when zoomed all the way out zooms in
                        this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
                    }
                }, {
                    key: "shouldHandleEvent",
                    value: function(source) {
                        if (this.eventsSource === source) return !0;
                        if (this.eventsSource === _constant.SOURCE_ANY) return this.eventsSource = source, 
                        !0;
                        switch (source) {
                          case _constant.SOURCE_MOUSE:
                            return !1;

                          case _constant.SOURCE_TOUCH:
                            return this.eventsSource = _constant.SOURCE_TOUCH, this.filterPointersBySource(), 
                            !0;

                          case _constant.SOURCE_POINTER:
                            return this.eventsSource === _constant.SOURCE_MOUSE && (this.eventsSource = _constant.SOURCE_POINTER, 
                            this.filterPointersBySource(), !0);

                          default:
                            return !1;
                        }
                    }
                }, {
                    key: "addPointer",
                    value: function(pointer) {
                        this.pointerList.push(pointer);
                    }
                }, {
                    key: "removePointer",
                    value: function(pointer) {
                        this.pointerList = this.pointerList.filter(function(_ref2) {
                            return _ref2.id !== pointer.id;
                        });
                    }
                }, {
                    key: "filterPointersBySource",
                    value: function() {
                        var _this8 = this;
                        this.pointerList = this.pointerList.filter(function(_ref3) {
                            return _ref3.source === _this8.eventsSource;
                        });
                    }
                }, {
                    key: "handleMouseDown",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parseMouseEvent(event)), 
                        this.multiPointerStart(event));
                    }
                }, {
                    key: "handleMouseMove",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && this.multiPointerMove(event, [ ReactImageLightbox.parseMouseEvent(event) ]);
                    }
                }, {
                    key: "handleMouseUp",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && (this.removePointer(ReactImageLightbox.parseMouseEvent(event)), 
                        this.multiPointerEnd(event));
                    }
                }, {
                    key: "handlePointerEvent",
                    value: function(event) {
                        if (this.shouldHandleEvent(_constant.SOURCE_POINTER)) switch (event.type) {
                          case "pointerdown":
                            ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parsePointerEvent(event)), 
                            this.multiPointerStart(event));
                            break;

                          case "pointermove":
                            this.multiPointerMove(event, [ ReactImageLightbox.parsePointerEvent(event) ]);
                            break;

                          case "pointerup":
                          case "pointercancel":
                            this.removePointer(ReactImageLightbox.parsePointerEvent(event)), this.multiPointerEnd(event);
                        }
                    }
                }, {
                    key: "handleTouchStart",
                    value: function(event) {
                        var _this9 = this;
                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target) && ([].forEach.call(event.changedTouches, function(eventTouch) {
                            return _this9.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
                        }), this.multiPointerStart(event));
                    }
                }, {
                    key: "handleTouchMove",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && this.multiPointerMove(event, [].map.call(event.changedTouches, function(eventTouch) {
                            return ReactImageLightbox.parseTouchPointer(eventTouch);
                        }));
                    }
                }, {
                    key: "handleTouchEnd",
                    value: function(event) {
                        var _this10 = this;
                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ([].map.call(event.changedTouches, function(touch) {
                            return _this10.removePointer(ReactImageLightbox.parseTouchPointer(touch));
                        }), this.multiPointerEnd(event));
                    }
                }, {
                    key: "decideMoveOrSwipe",
                    value: function(pointer) {
                        this.state.zoomLevel <= _constant.MIN_ZOOM_LEVEL ? this.handleSwipeStart(pointer) : this.handleMoveStart(pointer);
                    }
                }, {
                    key: "multiPointerStart",
                    value: function(event) {
                        switch (this.handleEnd(null), this.pointerList.length) {
                          case 1:
                            event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
                            break;

                          case 2:
                            event.preventDefault(), this.handlePinchStart(this.pointerList);
                        }
                    }
                }, {
                    key: "multiPointerMove",
                    value: function(event, pointerList) {
                        switch (this.currentAction) {
                          case _constant.ACTION_MOVE:
                            event.preventDefault(), this.handleMove(pointerList[0]);
                            break;

                          case _constant.ACTION_SWIPE:
                            event.preventDefault(), this.handleSwipe(pointerList[0]);
                            break;

                          case _constant.ACTION_PINCH:
                            event.preventDefault(), this.handlePinch(pointerList);
                        }
                    }
                }, {
                    key: "multiPointerEnd",
                    value: function(event) {
                        switch (this.currentAction !== _constant.ACTION_NONE && (this.setPreventInnerClose(), 
                        this.handleEnd(event)), this.pointerList.length) {
                          case 0:
                            this.eventsSource = _constant.SOURCE_ANY;
                            break;

                          case 1:
                            event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
                            break;

                          case 2:
                            event.preventDefault(), this.handlePinchStart(this.pointerList);
                        }
                    }
                }, {
                    key: "handleEnd",
                    value: function(event) {
                        switch (this.currentAction) {
                          case _constant.ACTION_MOVE:
                            this.handleMoveEnd(event);
                            break;

                          case _constant.ACTION_SWIPE:
                            this.handleSwipeEnd(event);
                            break;

                          case _constant.ACTION_PINCH:
                            this.handlePinchEnd(event);
                        }
                    }
                }, {
                    key: "handleMoveStart",
                    value: function(_ref4) {
                        var clientX = _ref4.x, clientY = _ref4.y;
                        this.props.enableZoom && (this.currentAction = _constant.ACTION_MOVE, this.moveStartX = clientX, 
                        this.moveStartY = clientY, this.moveStartOffsetX = this.state.offsetX, this.moveStartOffsetY = this.state.offsetY);
                    }
                }, {
                    key: "handleMove",
                    value: function(_ref5) {
                        var clientX = _ref5.x, clientY = _ref5.y, newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX, newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
                        this.state.offsetX === newOffsetX && this.state.offsetY === newOffsetY || this.setState({
                            offsetX: newOffsetX,
                            offsetY: newOffsetY
                        });
                    }
                }, {
                    key: "handleMoveEnd",
                    value: function() {
                        var _this11 = this;
                        this.currentAction = _constant.ACTION_NONE, this.moveStartX = 0, this.moveStartY = 0, 
                        this.moveStartOffsetX = 0, this.moveStartOffsetY = 0;
                        // Snap image back into frame if outside max offset range
                        var maxOffsets = this.getMaxOffsets(), nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX)), nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
                        nextOffsetX === this.state.offsetX && nextOffsetY === this.state.offsetY || (this.setState({
                            offsetX: nextOffsetX,
                            offsetY: nextOffsetY,
                            shouldAnimate: !0
                        }), this.setTimeout(function() {
                            _this11.setState({
                                shouldAnimate: !1
                            });
                        }, this.props.animationDuration));
                    }
                }, {
                    key: "handleSwipeStart",
                    value: function(_ref6) {
                        var clientX = _ref6.x, clientY = _ref6.y;
                        this.currentAction = _constant.ACTION_SWIPE, this.swipeStartX = clientX, this.swipeStartY = clientY, 
                        this.swipeEndX = clientX, this.swipeEndY = clientY;
                    }
                }, {
                    key: "handleSwipe",
                    value: function(_ref7) {
                        var clientX = _ref7.x, clientY = _ref7.y;
                        this.swipeEndX = clientX, this.swipeEndY = clientY;
                    }
                }, {
                    key: "handleSwipeEnd",
                    value: function(event) {
                        var xDiff = this.swipeEndX - this.swipeStartX, xDiffAbs = Math.abs(xDiff), yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
                        if (this.currentAction = _constant.ACTION_NONE, this.swipeStartX = 0, this.swipeStartY = 0, 
                        this.swipeEndX = 0, this.swipeEndY = 0, !(!event || this.isAnimating() || xDiffAbs < 1.5 * yDiffAbs)) {
                            if (xDiffAbs < _constant.MIN_SWIPE_DISTANCE) {
                                if (xDiffAbs < this.getLightboxRect().width / 4) return;
                            }
                            xDiff > 0 && this.props.prevSrc ? (event.preventDefault(), this.requestMovePrev()) : xDiff < 0 && this.props.nextSrc && (event.preventDefault(), 
                            this.requestMoveNext());
                        }
                    }
                }, {
                    key: "calculatePinchDistance",
                    value: function() {
                        var _ref8 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref9 = _slicedToArray(_ref8, 2), a = _ref9[0], b = _ref9[1];
                        return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
                    }
                }, {
                    key: "calculatePinchCenter",
                    value: function() {
                        var _ref10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref11 = _slicedToArray(_ref10, 2), a = _ref11[0], b = _ref11[1];
                        return {
                            x: a.x - (a.x - b.x) / 2,
                            y: a.y - (a.y - b.y) / 2
                        };
                    }
                }, {
                    key: "handlePinchStart",
                    value: function(pointerList) {
                        this.props.enableZoom && (this.currentAction = _constant.ACTION_PINCH, this.pinchTouchList = pointerList.map(function(_ref12) {
                            return {
                                id: _ref12.id,
                                x: _ref12.x,
                                y: _ref12.y
                            };
                        }), this.pinchDistance = this.calculatePinchDistance());
                    }
                }, {
                    key: "handlePinch",
                    value: function(pointerList) {
                        this.pinchTouchList = this.pinchTouchList.map(function(oldPointer) {
                            for (var i = 0; i < pointerList.length; i += 1) if (pointerList[i].id === oldPointer.id) return pointerList[i];
                            return oldPointer;
                        });
                        var newDistance = this.calculatePinchDistance(), zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
                        this.pinchDistance = newDistance;
                        var _calculatePinchCenter = this.calculatePinchCenter(this.pinchTouchList), clientX = _calculatePinchCenter.x, clientY = _calculatePinchCenter.y;
                        this.changeZoom(zoomLevel, clientX, clientY);
                    }
                }, {
                    key: "handlePinchEnd",
                    value: function() {
                        this.currentAction = _constant.ACTION_NONE, this.pinchTouchList = null, this.pinchDistance = 0;
                    }
                }, {
                    key: "handleWindowResize",
                    value: function() {
                        this.clearTimeout(this.resizeTimeout), this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
                    }
                }, {
                    key: "handleZoomInButtonClick",
                    value: function() {
                        this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE);
                    }
                }, {
                    key: "handleZoomOutButtonClick",
                    value: function() {
                        this.changeZoom(this.state.zoomLevel - _constant.ZOOM_BUTTON_INCREMENT_SIZE);
                    }
                }, {
                    key: "handleCaptionMousewheel",
                    value: function(event) {
                        if (event.stopPropagation(), this.caption) {
                            var _caption$getBoundingC = this.caption.getBoundingClientRect(), height = _caption$getBoundingC.height, _caption = this.caption, scrollHeight = _caption.scrollHeight, scrollTop = _caption.scrollTop;
                            (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) && event.preventDefault();
                        }
                    }
                }, {
                    key: "isAnimating",
                    value: function() {
                        return this.state.shouldAnimate || this.state.isClosing;
                    }
                }, {
                    key: "isImageLoaded",
                    value: function(imageSrc) {
                        return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
                    }
                }, {
                    key: "loadImage",
                    value: function(srcType, imageSrc, done) {
                        var _this12 = this;
                        // Return the image info if it is already cached
                        if (this.isImageLoaded(imageSrc)) return void this.setTimeout(function() {
                            done();
                        }, 1);
                        var inMemoryImage = new global.Image();
                        this.props.imageCrossOrigin && (inMemoryImage.crossOrigin = this.props.imageCrossOrigin), 
                        inMemoryImage.onerror = function(errorEvent) {
                            _this12.props.onImageLoadError(imageSrc, srcType, errorEvent), // failed to load so set the state loadErrorStatus
                            _this12.setState(function(prevState) {
                                return {
                                    loadErrorStatus: _extends({}, prevState.loadErrorStatus, _defineProperty({}, srcType, !0))
                                };
                            }), done(errorEvent);
                        }, inMemoryImage.onload = function() {
                            _this12.imageCache[imageSrc] = {
                                loaded: !0,
                                width: inMemoryImage.width,
                                height: inMemoryImage.height
                            }, done();
                        }, inMemoryImage.src = imageSrc;
                    }
                }, {
                    key: "loadAllImages",
                    value: function() {
                        var _this13 = this, props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props, generateLoadDoneCallback = function(srcType, imageSrc) {
                            return function(err) {
                                // Give up showing image on error
                                err || _this13.props[srcType] !== imageSrc || _this13.didUnmount || // Force rerender with the new image
                                _this13.forceUpdate();
                            };
                        };
                        // Load the images
                        this.getSrcTypes().forEach(function(srcType) {
                            var type = srcType.name;
                            // there is no error when we try to load it initially
                            props[type] && _this13.state.loadErrorStatus[type] && _this13.setState(function(prevState) {
                                return {
                                    loadErrorStatus: _extends({}, prevState.loadErrorStatus, _defineProperty({}, type, !1))
                                };
                            }), // Load unloaded images
                            props[type] && !_this13.isImageLoaded(props[type]) && _this13.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
                        });
                    }
                }, {
                    key: "requestClose",
                    value: function(event) {
                        var _this14 = this, closeLightbox = function() {
                            return _this14.props.onCloseRequest(event);
                        };
                        if (this.props.animationDisabled || "keydown" === event.type && !this.props.animationOnKeyInput) // No animation
                        return void closeLightbox();
                        // With animation
                        // Start closing animation
                        this.setState({
                            isClosing: !0
                        }), // Perform the actual closing at the end of the animation
                        this.setTimeout(closeLightbox, this.props.animationDuration);
                    }
                }, {
                    key: "requestMove",
                    value: function(direction, event) {
                        var _this15 = this, nextState = {
                            zoomLevel: _constant.MIN_ZOOM_LEVEL,
                            offsetX: 0,
                            offsetY: 0
                        };
                        // Enable animated states
                        this.props.animationDisabled || this.keyPressed && !this.props.animationOnKeyInput || (nextState.shouldAnimate = !0, 
                        this.setTimeout(function() {
                            return _this15.setState({
                                shouldAnimate: !1
                            });
                        }, this.props.animationDuration)), this.keyPressed = !1, this.moveRequested = !0, 
                        "prev" === direction ? (this.keyCounter -= 1, this.setState(nextState), this.props.onMovePrevRequest(event)) : (this.keyCounter += 1, 
                        this.setState(nextState), this.props.onMoveNextRequest(event));
                    }
                }, {
                    key: "requestMoveNext",
                    value: function(event) {
                        this.requestMove("next", event);
                    }
                }, {
                    key: "requestMovePrev",
                    value: function(event) {
                        this.requestMove("prev", event);
                    }
                }, {
                    key: "render",
                    value: function() {
                        var _this16 = this, _props = this.props, animationDisabled = _props.animationDisabled, animationDuration = _props.animationDuration, clickOutsideToClose = _props.clickOutsideToClose, discourageDownloads = _props.discourageDownloads, enableZoom = _props.enableZoom, imageTitle = _props.imageTitle, nextSrc = _props.nextSrc, prevSrc = _props.prevSrc, toolbarButtons = _props.toolbarButtons, reactModalStyle = _props.reactModalStyle, _onAfterOpen = _props.onAfterOpen, imageCrossOrigin = _props.imageCrossOrigin, reactModalProps = _props.reactModalProps, _state = this.state, zoomLevel = _state.zoomLevel, offsetX = _state.offsetX, offsetY = _state.offsetY, isClosing = _state.isClosing, loadErrorStatus = _state.loadErrorStatus, boxSize = this.getLightboxRect(), transitionStyle = {};
                        // Transition settings for sliding animations
                        !animationDisabled && this.isAnimating() && (transitionStyle = _extends({}, transitionStyle, {
                            transition: "transform " + animationDuration + "ms"
                        }));
                        // Key endings to differentiate between images with the same src
                        var keyEndings = {};
                        this.getSrcTypes().forEach(function(_ref13) {
                            var name = _ref13.name, keyEnding = _ref13.keyEnding;
                            keyEndings[name] = keyEnding;
                        });
                        // Images to be displayed
                        var images = [], addImage = function(srcType, imageClass, transforms) {
                            // Ignore types that have no source defined for their full size image
                            if (_this16.props[srcType]) {
                                var bestImageInfo = _this16.getBestImageForType(srcType), imageStyle = _extends({}, transitionStyle, ReactImageLightbox.getTransform(_extends({}, transforms, bestImageInfo)));
                                zoomLevel > _constant.MIN_ZOOM_LEVEL && (imageStyle.cursor = "move");
                                // when error on one of the loads then push custom error stuff
                                if (null === bestImageInfo && function(object) {
                                    return Object.keys(object).some(function(key) {
                                        return object[key];
                                    });
                                }(loadErrorStatus)) return void images.push(_react2.default.createElement("div", {
                                    className: imageClass + " " + styles.image + " ril-errored",
                                    style: imageStyle,
                                    key: _this16.props[srcType] + keyEndings[srcType]
                                }, _react2.default.createElement("div", {
                                    className: styles.errorContainer
                                }, _this16.props.imageLoadErrorMessage)));
                                if (null === bestImageInfo) {
                                    var loadingIcon = ieVersion < 10 ? _react2.default.createElement("div", {
                                        className: styles.loadingContainer__icon
                                    }, (0, _util.translate)("Loading...")) : _react2.default.createElement("div", {
                                        className: "ril-loading-circle " + styles.loadingCircle + " " + styles.loadingContainer__icon
                                    }, [].concat(_toConsumableArray(new Array(12))).map(function(_, index) {
                                        return _react2.default.createElement("div", {
                                            // eslint-disable-next-line react/no-array-index-key
                                            key: index,
                                            className: "ril-loading-circle-point " + styles.loadingCirclePoint
                                        });
                                    }));
                                    // Fall back to loading icon if the thumbnail has not been loaded
                                    return void images.push(_react2.default.createElement("div", {
                                        className: imageClass + " " + styles.image + " ril-not-loaded",
                                        style: imageStyle,
                                        key: _this16.props[srcType] + keyEndings[srcType]
                                    }, _react2.default.createElement("div", {
                                        className: styles.loadingContainer
                                    }, loadingIcon)));
                                }
                                var imageSrc = bestImageInfo.src;
                                discourageDownloads ? (imageStyle.backgroundImage = "url('" + imageSrc + "')", images.push(_react2.default.createElement("div", {
                                    className: imageClass + " " + styles.image + " " + styles.imageDiscourager,
                                    onDoubleClick: _this16.handleImageDoubleClick,
                                    onWheel: _this16.handleImageMouseWheel,
                                    style: imageStyle,
                                    key: imageSrc + keyEndings[srcType]
                                }, _react2.default.createElement("div", {
                                    className: "ril-download-blocker " + styles.downloadBlocker
                                })))) : images.push(_react2.default.createElement("img", _extends({}, imageCrossOrigin ? {
                                    crossOrigin: imageCrossOrigin
                                } : {}, {
                                    className: imageClass + " " + styles.image,
                                    onDoubleClick: _this16.handleImageDoubleClick,
                                    onWheel: _this16.handleImageMouseWheel,
                                    onDragStart: function(e) {
                                        return e.preventDefault();
                                    },
                                    style: imageStyle,
                                    src: imageSrc,
                                    key: imageSrc + keyEndings[srcType],
                                    alt: "string" == typeof imageTitle ? imageTitle : (0, _util.translate)("Image"),
                                    draggable: !1
                                })));
                            }
                        }, zoomMultiplier = this.getZoomMultiplier();
                        // Next Image (displayed on the right)
                        addImage("nextSrc", "ril-image-next " + styles.imageNext, {
                            x: boxSize.width
                        }), // Main Image
                        addImage("mainSrc", "ril-image-current", {
                            x: -1 * offsetX,
                            y: -1 * offsetY,
                            zoom: zoomMultiplier
                        }), // Previous Image (displayed on the left)
                        addImage("prevSrc", "ril-image-prev " + styles.imagePrev, {
                            x: -1 * boxSize.width
                        });
                        var modalStyle = {
                            overlay: _extends({
                                zIndex: 1e3,
                                backgroundColor: "transparent"
                            }, reactModalStyle.overlay),
                            content: _extends({
                                backgroundColor: "transparent",
                                overflow: "hidden",
                                // Needed, otherwise keyboard shortcuts scroll the page
                                border: "none",
                                borderRadius: 0,
                                padding: 0,
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            }, reactModalStyle.content)
                        };
                        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                        return _react2.default.createElement(_reactModal2.default, _extends({
                            isOpen: !0,
                            onRequestClose: clickOutsideToClose ? this.requestClose : void 0,
                            onAfterOpen: function() {
                                // Focus on the div with key handlers
                                _this16.outerEl && _this16.outerEl.focus(), _onAfterOpen();
                            },
                            style: modalStyle,
                            contentLabel: (0, _util.translate)("Lightbox"),
                            appElement: void 0 !== global.window ? global.window.document.body : void 0
                        }, reactModalProps), _react2.default.createElement("div", {
                            // eslint-disable-line jsx-a11y/no-static-element-interactions
                            // Floating modal with closing animations
                            className: "ril-outer " + styles.outer + " " + styles.outerAnimating + " " + this.props.wrapperClassName + " " + (isClosing ? "ril-closing " + styles.outerClosing : ""),
                            style: {
                                transition: "opacity " + animationDuration + "ms",
                                animationDuration: animationDuration + "ms",
                                animationDirection: isClosing ? "normal" : "reverse"
                            },
                            ref: function(el) {
                                _this16.outerEl = el;
                            },
                            onWheel: this.handleOuterMousewheel,
                            onMouseMove: this.handleMouseMove,
                            onMouseDown: this.handleMouseDown,
                            onTouchStart: this.handleTouchStart,
                            onTouchMove: this.handleTouchMove,
                            tabIndex: "-1",
                            onKeyDown: this.handleKeyInput,
                            onKeyUp: this.handleKeyInput
                        }, _react2.default.createElement("div", {
                            // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                            // Image holder
                            className: "ril-inner " + styles.inner,
                            onClick: clickOutsideToClose ? this.closeIfClickInner : void 0
                        }, images), prevSrc && _react2.default.createElement("button", {
                            // Move to previous image button
                            type: "button",
                            className: "ril-prev-button " + styles.navButtons + " " + styles.navButtonPrev,
                            key: "prev",
                            "aria-label": this.props.prevLabel,
                            onClick: this.isAnimating() ? void 0 : this.requestMovePrev
                        }), nextSrc && _react2.default.createElement("button", {
                            // Move to next image button
                            type: "button",
                            className: "ril-next-button " + styles.navButtons + " " + styles.navButtonNext,
                            key: "next",
                            "aria-label": this.props.nextLabel,
                            onClick: this.isAnimating() ? void 0 : this.requestMoveNext
                        }), _react2.default.createElement("div", {
                            // Lightbox toolbar
                            className: "ril-toolbar " + styles.toolbar
                        }, _react2.default.createElement("ul", {
                            className: "ril-toolbar-left " + styles.toolbarSide + " " + styles.toolbarLeftSide
                        }, _react2.default.createElement("li", {
                            className: "ril-toolbar__item " + styles.toolbarItem
                        }, _react2.default.createElement("span", {
                            className: "ril-toolbar__item__child " + styles.toolbarItemChild
                        }, imageTitle))), _react2.default.createElement("ul", {
                            className: [ "ril-toolbar-right", styles.toolbarSide, styles.toolbarRightSide ].join(" ")
                        }, toolbarButtons && toolbarButtons.map(function(button, i) {
                            return _react2.default.createElement("li", {
                                key: "button_" + (i + 1),
                                className: "ril-toolbar__item " + styles.toolbarItem
                            }, button);
                        }), enableZoom && _react2.default.createElement("li", {
                            className: "ril-toolbar__item " + styles.toolbarItem
                        }, _react2.default.createElement("button", {
                            // Lightbox zoom in button
                            type: "button",
                            key: "zoom-in",
                            "aria-label": this.props.zoomInLabel,
                            className: [ "ril-zoom-in", styles.toolbarItemChild, styles.builtinButton, styles.zoomInButton ].concat(_toConsumableArray(zoomLevel === _constant.MAX_ZOOM_LEVEL ? [ styles.builtinButtonDisabled ] : [])).join(" "),
                            disabled: this.isAnimating() || zoomLevel === _constant.MAX_ZOOM_LEVEL,
                            onClick: this.isAnimating() || zoomLevel === _constant.MAX_ZOOM_LEVEL ? void 0 : this.handleZoomInButtonClick
                        })), enableZoom && _react2.default.createElement("li", {
                            className: "ril-toolbar__item " + styles.toolbarItem
                        }, _react2.default.createElement("button", {
                            // Lightbox zoom out button
                            type: "button",
                            key: "zoom-out",
                            "aria-label": this.props.zoomOutLabel,
                            className: [ "ril-zoom-out", styles.toolbarItemChild, styles.builtinButton, styles.zoomOutButton ].concat(_toConsumableArray(zoomLevel === _constant.MIN_ZOOM_LEVEL ? [ styles.builtinButtonDisabled ] : [])).join(" "),
                            disabled: this.isAnimating() || zoomLevel === _constant.MIN_ZOOM_LEVEL,
                            onClick: this.isAnimating() || zoomLevel === _constant.MIN_ZOOM_LEVEL ? void 0 : this.handleZoomOutButtonClick
                        })), _react2.default.createElement("li", {
                            className: "ril-toolbar__item " + styles.toolbarItem
                        }, _react2.default.createElement("button", {
                            // Lightbox close button
                            type: "button",
                            key: "close",
                            "aria-label": this.props.closeLabel,
                            className: "ril-close ril-toolbar__item__child " + styles.toolbarItemChild + " " + styles.builtinButton + " " + styles.closeButton,
                            onClick: this.isAnimating() ? void 0 : this.requestClose
                        })))), this.props.imageCaption && _react2.default.createElement("div", {
                            // Image caption
                            onWheel: this.handleCaptionMousewheel,
                            onMouseDown: function(event) {
                                return event.stopPropagation();
                            },
                            className: "ril-caption " + styles.caption,
                            ref: function(el) {
                                _this16.caption = el;
                            }
                        }, _react2.default.createElement("div", {
                            className: "ril-caption-content " + styles.captionContent
                        }, this.props.imageCaption))));
                    }
                } ]), ReactImageLightbox;
            }(_react.Component);
            ReactImageLightbox.propTypes = {
                //-----------------------------
                // Image sources
                //-----------------------------
                // Main display image url
                mainSrc: _propTypes2.default.string.isRequired,
                // eslint-disable-line react/no-unused-prop-types
                // Previous display image url (displayed to the left)
                // If left undefined, movePrev actions will not be performed, and the button not displayed
                prevSrc: _propTypes2.default.string,
                // Next display image url (displayed to the right)
                // If left undefined, moveNext actions will not be performed, and the button not displayed
                nextSrc: _propTypes2.default.string,
                //-----------------------------
                // Image thumbnail sources
                //-----------------------------
                // Thumbnail image url corresponding to props.mainSrc
                mainSrcThumbnail: _propTypes2.default.string,
                // eslint-disable-line react/no-unused-prop-types
                // Thumbnail image url corresponding to props.prevSrc
                prevSrcThumbnail: _propTypes2.default.string,
                // eslint-disable-line react/no-unused-prop-types
                // Thumbnail image url corresponding to props.nextSrc
                nextSrcThumbnail: _propTypes2.default.string,
                // eslint-disable-line react/no-unused-prop-types
                //-----------------------------
                // Event Handlers
                //-----------------------------
                // Close window event
                // Should change the parent state such that the lightbox is not rendered
                onCloseRequest: _propTypes2.default.func.isRequired,
                // Move to previous image event
                // Should change the parent state such that props.prevSrc becomes props.mainSrc,
                //  props.mainSrc becomes props.nextSrc, etc.
                onMovePrevRequest: _propTypes2.default.func,
                // Move to next image event
                // Should change the parent state such that props.nextSrc becomes props.mainSrc,
                //  props.mainSrc becomes props.prevSrc, etc.
                onMoveNextRequest: _propTypes2.default.func,
                // Called when an image fails to load
                // (imageSrc: string, srcType: string, errorEvent: object): void
                onImageLoadError: _propTypes2.default.func,
                // Open window event
                onAfterOpen: _propTypes2.default.func,
                //-----------------------------
                // Download discouragement settings
                //-----------------------------
                // Enable download discouragement (prevents [right-click -> Save Image As...])
                discourageDownloads: _propTypes2.default.bool,
                //-----------------------------
                // Animation settings
                //-----------------------------
                // Disable all animation
                animationDisabled: _propTypes2.default.bool,
                // Disable animation on actions performed with keyboard shortcuts
                animationOnKeyInput: _propTypes2.default.bool,
                // Animation duration (ms)
                animationDuration: _propTypes2.default.number,
                //-----------------------------
                // Keyboard shortcut settings
                //-----------------------------
                // Required interval of time (ms) between key actions
                // (prevents excessively fast navigation of images)
                keyRepeatLimit: _propTypes2.default.number,
                // Amount of time (ms) restored after each keyup
                // (makes rapid key presses slightly faster than holding down the key to navigate images)
                keyRepeatKeyupBonus: _propTypes2.default.number,
                //-----------------------------
                // Image info
                //-----------------------------
                // Image title
                imageTitle: _propTypes2.default.node,
                // Image caption
                imageCaption: _propTypes2.default.node,
                // Optional crossOrigin attribute
                imageCrossOrigin: _propTypes2.default.string,
                //-----------------------------
                // Lightbox style
                //-----------------------------
                // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
                reactModalStyle: _propTypes2.default.shape({}),
                // Padding (px) between the edge of the window and the lightbox
                imagePadding: _propTypes2.default.number,
                wrapperClassName: _propTypes2.default.string,
                //-----------------------------
                // Other
                //-----------------------------
                // Array of custom toolbar buttons
                toolbarButtons: _propTypes2.default.arrayOf(_propTypes2.default.node),
                // When true, clicks outside of the image close the lightbox
                clickOutsideToClose: _propTypes2.default.bool,
                // Set to false to disable zoom functionality and hide zoom buttons
                enableZoom: _propTypes2.default.bool,
                // Override props set on react-modal (https://github.com/reactjs/react-modal)
                reactModalProps: _propTypes2.default.shape({}),
                // Aria-labels
                nextLabel: _propTypes2.default.string,
                prevLabel: _propTypes2.default.string,
                zoomInLabel: _propTypes2.default.string,
                zoomOutLabel: _propTypes2.default.string,
                closeLabel: _propTypes2.default.string,
                imageLoadErrorMessage: _propTypes2.default.node
            }, ReactImageLightbox.defaultProps = {
                imageTitle: null,
                imageCaption: null,
                toolbarButtons: null,
                reactModalProps: {},
                animationDisabled: !1,
                animationDuration: 300,
                animationOnKeyInput: !1,
                clickOutsideToClose: !0,
                closeLabel: "Close lightbox",
                discourageDownloads: !1,
                enableZoom: !0,
                imagePadding: 10,
                imageCrossOrigin: null,
                keyRepeatKeyupBonus: 40,
                keyRepeatLimit: 180,
                mainSrcThumbnail: null,
                nextLabel: "Next image",
                nextSrc: null,
                nextSrcThumbnail: null,
                onAfterOpen: function() {},
                onImageLoadError: function() {},
                onMoveNextRequest: function() {},
                onMovePrevRequest: function() {},
                prevLabel: "Previous image",
                prevSrc: null,
                prevSrcThumbnail: null,
                reactModalStyle: {},
                wrapperClassName: "",
                zoomInLabel: "Zoom in",
                zoomOutLabel: "Zoom out",
                imageLoadErrorMessage: "This image failed to load"
            }, exports.default = ReactImageLightbox;
        }).call(exports, __webpack_require__(0));
    }, /* 3 */
    /***/
    function(module, exports) {
        module.exports = require("react");
    }, /* 4 */
    /***/
    function(module, exports) {
        module.exports = require("prop-types");
    }, /* 5 */
    /***/
    function(module, exports) {
        module.exports = require("react-modal");
    }, /* 6 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */
        (function(global) {
            /**
 * Get the version of Internet Explorer in use, or undefined
 *
 * @return {?number} ieVersion - IE version as an integer, or undefined if not IE
 */
            function getIEVersion() {
                if (void 0 !== global.window && void 0 !== global.window.navigator) {
                    var match = global.window.navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
                    return match ? parseInt(match[1], 10) : void 0;
                }
            }
            /**
 * Placeholder for future translate functionality
 */
            function translate(str) {
                var replaceStrings = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                if (!str) return "";
                var translated = str;
                return replaceStrings && Object.keys(replaceStrings).forEach(function(placeholder) {
                    translated = translated.replace(placeholder, replaceStrings[placeholder]);
                }), translated;
            }
            function getWindowWidth() {
                return void 0 !== global.window ? global.window.innerWidth : 0;
            }
            function getWindowHeight() {
                return void 0 !== global.window ? global.window.innerHeight : 0;
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.getIEVersion = getIEVersion, exports.translate = translate, exports.getWindowWidth = getWindowWidth, 
            exports.getWindowHeight = getWindowHeight;
        }).call(exports, __webpack_require__(0));
    }, /* 7 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        // Min image zoom level
        exports.MIN_ZOOM_LEVEL = 0, exports.MAX_ZOOM_LEVEL = 300, exports.ZOOM_RATIO = 1.007, 
        exports.ZOOM_BUTTON_INCREMENT_SIZE = 100, exports.WHEEL_MOVE_X_THRESHOLD = 200, 
        exports.WHEEL_MOVE_Y_THRESHOLD = 1, exports.KEYS = {
            ESC: 27,
            LEFT_ARROW: 37,
            RIGHT_ARROW: 39
        }, exports.ACTION_NONE = 0, exports.ACTION_MOVE = 1, exports.ACTION_SWIPE = 2, exports.ACTION_PINCH = 3, 
        exports.ACTION_ROTATE = 4, exports.SOURCE_ANY = 0, exports.SOURCE_MOUSE = 1, exports.SOURCE_TOUCH = 2, 
        exports.SOURCE_POINTER = 3, exports.MIN_SWIPE_DISTANCE = 200;
    }, /* 8 */
    /***/
    function(module, exports, __webpack_require__) {
        var content = __webpack_require__(9), insertCss = __webpack_require__(11);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), module.exports = content.locals || {}, 
        module.exports._getContent = function() {
            return content;
        }, module.exports._getCss = function() {
            return content.toString();
        }, module.exports._insertCss = function(options) {
            return insertCss(content, options);
        };
    }, /* 9 */
    /***/
    function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(10)(!1), // imports
        // module
        exports.push([ module.i, '@-webkit-keyframes ril__closeWindow {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ril__closeWindow {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.ril__outer {\n  background-color: rgba(0, 0, 0, 0.85);\n  outline: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  -ms-content-zooming: none;\n  -ms-user-select: none;\n  -ms-touch-select: none;\n  -ms-touch-action: none;\n      touch-action: none; }\n\n.ril__outerClosing {\n  opacity: 0; }\n\n.ril__inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.ril__image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  max-width: none;\n  -ms-content-zooming: none;\n  -ms-user-select: none;\n  -ms-touch-select: none;\n  -ms-touch-action: none;\n      touch-action: none; }\n\n.ril__imagePrev {\n  @extends .image; }\n\n.ril__imageNext {\n  @extends .image; }\n\n.ril__imageDiscourager {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain; }\n\n.ril__navButtons {\n  border: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  height: 34px;\n  padding: 40px 30px;\n  margin: auto;\n  cursor: pointer;\n  opacity: 0.7; }\n  .ril__navButtons:hover {\n    opacity: 1; }\n  .ril__navButtons:active {\n    opacity: 0.7; }\n\n.ril__navButtonPrev {\n  left: 0;\n  background: rgba(0, 0, 0, 0.2) url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==") no-repeat center; }\n\n.ril__navButtonNext {\n  right: 0;\n  background: rgba(0, 0, 0, 0.2) url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+") no-repeat center; }\n\n.ril__downloadBlocker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");\n  background-size: cover; }\n\n.ril__caption,\n.ril__toolbar {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  left: 0;\n  right: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n.ril__caption {\n  bottom: 0;\n  max-height: 150px;\n  overflow: auto; }\n\n.ril__captionContent {\n  padding: 10px 20px;\n  color: #fff; }\n\n.ril__toolbar {\n  top: 0;\n  height: 50px; }\n\n.ril__toolbarSide {\n  height: 50px;\n  margin: 0; }\n\n.ril__toolbarSideNoFlex {\n  height: auto;\n  line-height: 50px;\n  max-width: 48%;\n  position: absolute;\n  top: 0;\n  bottom: 0; }\n\n.ril__toolbarLeftSide {\n  padding-left: 20px;\n  padding-right: 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.ril__toolbarLeftSideNoFlex {\n  left: 0;\n  overflow: visible; }\n\n.ril__toolbarRightSide {\n  padding-left: 0;\n  padding-right: 20px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto; }\n\n.ril__toolbarRightSideNoFlex {\n  right: 0; }\n\n.ril__toolbarItem {\n  display: inline-block;\n  line-height: 50px;\n  padding: 0;\n  color: #fff;\n  font-size: 120%;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.ril__toolbarItemChild {\n  vertical-align: middle; }\n\n.ril__builtinButton {\n  width: 40px;\n  height: 35px;\n  cursor: pointer;\n  border: none;\n  opacity: 0.7; }\n  .ril__builtinButton:hover {\n    opacity: 1; }\n  .ril__builtinButton:active {\n    outline: none; }\n\n.ril__builtinButtonDisabled {\n  cursor: default;\n  opacity: 0.5; }\n  .ril__builtinButtonDisabled:hover {\n    opacity: 0.5; }\n\n.ril__closeButton {\n  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=") no-repeat center; }\n\n.ril__zoomInButton {\n  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+") no-repeat center; }\n\n.ril__zoomOutButton {\n  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=") no-repeat center; }\n\n.ril__outerAnimating {\n  -webkit-animation-name: ril__closeWindow;\n          animation-name: ril__closeWindow; }\n\n@-webkit-keyframes ril__pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0; }\n  20% {\n    opacity: 1; } }\n\n@keyframes ril__pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0; }\n  20% {\n    opacity: 1; } }\n\n.ril__loadingCircle {\n  width: 60px;\n  height: 60px;\n  position: relative; }\n\n.ril__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0; }\n  .ril__loadingCirclePoint:before {\n    content: \'\';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: #fff;\n    border-radius: 30%;\n    -webkit-animation: ril__pointFade 1200ms infinite ease-in-out both;\n            animation: ril__pointFade 1200ms infinite ease-in-out both; }\n  .ril__loadingCirclePoint:nth-of-type(1) {\n    -webkit-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  .ril__loadingCirclePoint:nth-of-type(7) {\n    -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  .ril__loadingCirclePoint:nth-of-type(1):before, .ril__loadingCirclePoint:nth-of-type(7):before {\n    -webkit-animation-delay: -1200ms;\n            animation-delay: -1200ms; }\n  .ril__loadingCirclePoint:nth-of-type(2) {\n    -webkit-transform: rotate(30deg);\n        -ms-transform: rotate(30deg);\n            transform: rotate(30deg); }\n  .ril__loadingCirclePoint:nth-of-type(8) {\n    -webkit-transform: rotate(210deg);\n        -ms-transform: rotate(210deg);\n            transform: rotate(210deg); }\n  .ril__loadingCirclePoint:nth-of-type(2):before, .ril__loadingCirclePoint:nth-of-type(8):before {\n    -webkit-animation-delay: -1000ms;\n            animation-delay: -1000ms; }\n  .ril__loadingCirclePoint:nth-of-type(3) {\n    -webkit-transform: rotate(60deg);\n        -ms-transform: rotate(60deg);\n            transform: rotate(60deg); }\n  .ril__loadingCirclePoint:nth-of-type(9) {\n    -webkit-transform: rotate(240deg);\n        -ms-transform: rotate(240deg);\n            transform: rotate(240deg); }\n  .ril__loadingCirclePoint:nth-of-type(3):before, .ril__loadingCirclePoint:nth-of-type(9):before {\n    -webkit-animation-delay: -800ms;\n            animation-delay: -800ms; }\n  .ril__loadingCirclePoint:nth-of-type(4) {\n    -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n            transform: rotate(90deg); }\n  .ril__loadingCirclePoint:nth-of-type(10) {\n    -webkit-transform: rotate(270deg);\n        -ms-transform: rotate(270deg);\n            transform: rotate(270deg); }\n  .ril__loadingCirclePoint:nth-of-type(4):before, .ril__loadingCirclePoint:nth-of-type(10):before {\n    -webkit-animation-delay: -600ms;\n            animation-delay: -600ms; }\n  .ril__loadingCirclePoint:nth-of-type(5) {\n    -webkit-transform: rotate(120deg);\n        -ms-transform: rotate(120deg);\n            transform: rotate(120deg); }\n  .ril__loadingCirclePoint:nth-of-type(11) {\n    -webkit-transform: rotate(300deg);\n        -ms-transform: rotate(300deg);\n            transform: rotate(300deg); }\n  .ril__loadingCirclePoint:nth-of-type(5):before, .ril__loadingCirclePoint:nth-of-type(11):before {\n    -webkit-animation-delay: -400ms;\n            animation-delay: -400ms; }\n  .ril__loadingCirclePoint:nth-of-type(6) {\n    -webkit-transform: rotate(150deg);\n        -ms-transform: rotate(150deg);\n            transform: rotate(150deg); }\n  .ril__loadingCirclePoint:nth-of-type(12) {\n    -webkit-transform: rotate(330deg);\n        -ms-transform: rotate(330deg);\n            transform: rotate(330deg); }\n  .ril__loadingCirclePoint:nth-of-type(6):before, .ril__loadingCirclePoint:nth-of-type(12):before {\n    -webkit-animation-delay: -200ms;\n            animation-delay: -200ms; }\n  .ril__loadingCirclePoint:nth-of-type(7) {\n    -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  .ril__loadingCirclePoint:nth-of-type(13) {\n    -webkit-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n            transform: rotate(360deg); }\n  .ril__loadingCirclePoint:nth-of-type(7):before, .ril__loadingCirclePoint:nth-of-type(13):before {\n    -webkit-animation-delay: 0ms;\n            animation-delay: 0ms; }\n\n.ril__loadingContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n  .ril__imagePrev .ril__loadingContainer {\n    display: none; }\n  .ril__imageNext .ril__loadingContainer {\n    display: none; }\n\n.ril__errorContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: #fff; }\n  .ril__imagePrev .ril__errorContainer {\n    display: none; }\n  .ril__imageNext .ril__errorContainer {\n    display: none; }\n\n.ril__loadingContainer__icon {\n  color: #fff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n      -ms-transform: translateX(-50%) translateY(-50%);\n          transform: translateX(-50%) translateY(-50%); }\n', "" ]), 
        // exports
        exports.locals = {
            outer: "ril__outer",
            outerClosing: "ril__outerClosing",
            inner: "ril__inner",
            image: "ril__image",
            imagePrev: "ril__imagePrev",
            imageNext: "ril__imageNext",
            imageDiscourager: "ril__imageDiscourager",
            navButtons: "ril__navButtons",
            navButtonPrev: "ril__navButtonPrev",
            navButtonNext: "ril__navButtonNext",
            downloadBlocker: "ril__downloadBlocker",
            caption: "ril__caption",
            toolbar: "ril__toolbar",
            captionContent: "ril__captionContent",
            toolbarSide: "ril__toolbarSide",
            toolbarSideNoFlex: "ril__toolbarSideNoFlex",
            toolbarLeftSide: "ril__toolbarLeftSide",
            toolbarLeftSideNoFlex: "ril__toolbarLeftSideNoFlex",
            toolbarRightSide: "ril__toolbarRightSide",
            toolbarRightSideNoFlex: "ril__toolbarRightSideNoFlex",
            toolbarItem: "ril__toolbarItem",
            toolbarItemChild: "ril__toolbarItemChild",
            builtinButton: "ril__builtinButton",
            builtinButtonDisabled: "ril__builtinButtonDisabled",
            closeButton: "ril__closeButton",
            zoomInButton: "ril__zoomInButton",
            zoomOutButton: "ril__zoomOutButton",
            outerAnimating: "ril__outerAnimating",
            closeWindow: "ril__closeWindow",
            loadingCircle: "ril__loadingCircle",
            loadingCirclePoint: "ril__loadingCirclePoint",
            pointFade: "ril__pointFade",
            loadingContainer: "ril__loadingContainer",
            errorContainer: "ril__errorContainer",
            loadingContainer__icon: "ril__loadingContainer__icon"
        };
    }, /* 10 */
    /***/
    function(module, exports) {
        function cssWithMappingToString(item, useSourceMap) {
            var content = item[1] || "", cssMapping = item[3];
            if (!cssMapping) return content;
            if (useSourceMap && "function" == typeof btoa) {
                var sourceMapping = toComment(cssMapping);
                return [ content ].concat(cssMapping.sources.map(function(source) {
                    return "/*# sourceURL=" + cssMapping.sourceRoot + source + " */";
                })).concat([ sourceMapping ]).join("\n");
            }
            return [ content ].join("\n");
        }
        // Adapted from convert-source-map (MIT)
        function toComment(sourceMap) {
            return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
        }
        /*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
        // css base code, injected by the css-loader
        module.exports = function(useSourceMap) {
            var list = [];
            // return the list of modules as css string
            // import a list of modules into the list
            return list.toString = function() {
                return this.map(function(item) {
                    var content = cssWithMappingToString(item, useSourceMap);
                    return item[2] ? "@media " + item[2] + "{" + content + "}" : content;
                }).join("");
            }, list.i = function(modules, mediaQuery) {
                "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
                for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                    var id = this[i][0];
                    "number" == typeof id && (alreadyImportedModules[id] = !0);
                }
                for (i = 0; i < modules.length; i++) {
                    var item = modules[i];
                    // skip already imported module
                    // this implementation is not 100% perfect for weird media query combinations
                    //  when a module is imported multiple times with different media queries.
                    //  I hope this will never occur (Hey this way we have smaller bundles)
                    "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                    list.push(item));
                }
            }, list;
        };
    }, /* 11 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        // Base64 encoding and decoding - The "Unicode Problem"
        // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
        function b64EncodeUnicode(str) {
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
                return String.fromCharCode("0x" + p1);
            }));
        }
        /**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
        function removeCss(ids) {
            ids.forEach(function(id) {
                if (--inserted[id] <= 0) {
                    var elem = document.getElementById(prefix + id);
                    elem && elem.parentNode.removeChild(elem);
                }
            });
        }
        /**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
        function insertCss(styles) {
            for (var _ref = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _ref$replace = _ref.replace, replace = void 0 !== _ref$replace && _ref$replace, _ref$prepend = _ref.prepend, prepend = void 0 !== _ref$prepend && _ref$prepend, ids = [], i = 0; i < styles.length; i++) {
                var _styles$i = (0, _slicedToArray3.default)(styles[i], 4), moduleId = _styles$i[0], css = _styles$i[1], media = _styles$i[2], sourceMap = _styles$i[3], id = moduleId + "-" + i;
                if (ids.push(id), !inserted[id] || replace) {
                    inserted[id] = 1;
                    var elem = document.getElementById(prefix + id), create = !1;
                    elem || (create = !0, elem = document.createElement("style"), elem.setAttribute("type", "text/css"), 
                    elem.id = prefix + id, media && elem.setAttribute("media", media));
                    var cssText = css;
                    sourceMap && "function" == typeof btoa && (// skip IE9 and below, see http://caniuse.com/atob-btoa
                    cssText += "\n/*# sourceMappingURL=data:application/json;base64," + b64EncodeUnicode((0, 
                    _stringify2.default)(sourceMap)) + "*/", cssText += "\n/*# sourceURL=" + sourceMap.file + "?" + id + "*/"), 
                    "textContent" in elem ? elem.textContent = cssText : elem.styleSheet.cssText = cssText, 
                    create && (prepend ? document.head.insertBefore(elem, document.head.childNodes[0]) : document.head.appendChild(elem));
                } else inserted[id]++;
            }
            return removeCss.bind(null, ids);
        }
        var _stringify = __webpack_require__(12), _stringify2 = _interopRequireDefault(_stringify), _slicedToArray2 = __webpack_require__(13), _slicedToArray3 = _interopRequireDefault(_slicedToArray2), prefix = "s", inserted = {};
        module.exports = insertCss;
    }, /* 12 */
    /***/
    function(module, exports) {
        module.exports = require("babel-runtime/core-js/json/stringify");
    }, /* 13 */
    /***/
    function(module, exports) {
        module.exports = require("babel-runtime/helpers/slicedToArray");
    } ]);
});


//////////////////
// WEBPACK FOOTER
// ./~/react-image-lightbox/dist/main.js
// module id = 582
// module chunks = 169021755776161